import { useMutation } from '@tanstack/react-query'

import { putTransactionEvidenceEmailsMoveToTrash } from '@src/api'
import { DefaultApiPutTransactionEvidenceEmailsMoveToTrashRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const usePutTransactionEvidenceEmailsMoveToTrash = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (
      params: DefaultApiPutTransactionEvidenceEmailsMoveToTrashRequest
    ) => putTransactionEvidenceEmailsMoveToTrash(axiosInstance, params),
  })
}
